import { JoineryType } from "@rhinov/savane-js";
import { ComponentWidget } from "./ComponentWidget";
import { _ASSET_TYPE, getAsset, getToken } from "@rhinov/asset-manager-service";



export class JoineryTypeComponentWidget  extends ComponentWidget{
    constructor (component: JoineryType, index: number) {
        super(component, index);
        this.component = component;
        this.index = index;
    }

    init(endCallback: CallableFunction) {
        getAsset(_ASSET_TYPE.JOINERIES, (this.component as JoineryType).joineryTypeId, getToken(),
            (res: any) => {
                (this.component as any).infos = res;
                endCallback();
        });
    }
    
    html(): string {
        return this.CommonHeader(false);
    }
}